document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('lottery-form');
  if (!form) return;

  const submitButton = document.getElementById('lottery-submit');
  const message = document.getElementById('lottery-message');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    data.application_products =
      'YUTO HORIGOME × NIKE SB - AIR FORCE 1 "Iron Grey"';
    data.sneaker_size = data.sneaker_size || '';
    data.accepts_marketing = formData.has('accepts_marketing')
      ? 'true'
      : 'false';

    const storageKey = `lottery_${data.collection_handle}`;

    if (localStorage.getItem(storageKey)) {
      message.textContent = 'すでにご応募いただいています。';
      message.style.color = 'red';
      return;
    }

    submitButton.disabled = true;
    const buttonText = submitButton.querySelector('.btn-text');

    if (buttonText) {
      buttonText.textContent = '送信中...';
    }

    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbxgyiLe2P-As3k390_eyfryvYQkgF2lADxk5S9q2h76nEGKt7el053YMlPeYJ5nJx-TLA/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );

      localStorage.setItem(storageKey, '1');

      form.innerHTML = `
        <div class="lottery-success">
          <p>
            ご応募ありがとうございます。<br>
            当選者様にはこちらからメールにてご連絡致します。
          </p>
        </div>
      `;
    } catch (error) {
      console.error('Lottery form submission error:', error);
      message.textContent =
        '送信に失敗しました。時間をおいて再度お試しください。';
      message.style.color = 'red';
      submitButton.disabled = false;

      if (buttonText) {
        buttonText.textContent = '応募する';
      }
    }
  });
});
